export var SUPPORTED_LANGUAGES = ['de', 'en', 'it', 'nl', 'fr', 'da', 'hu', 'es'];
export var DEFAULT_LANGUAGE = 'en';
export var DEV_LANGUAGES = [].concat(SUPPORTED_LANGUAGES, ['phrase']);